import { CSvgTrash , CSvgBook , CSvgEdit } from "icon"


export const Bots = () => {




  return (
    <>
      <div className='w-full flex flex-col justify-center items-center pb-[20px] bg-hoory-100  rounded-lg  '>
        <div className="w-full flex flex-wrap  p-4">
          <div className="md:w-6/12 w-full md:pr-4 pr-0">
            <div className='w-full flex flex-col '>
              {[0, 0, 0, 0, 0, 0, 0, 0, 0].map((item: any, index: number) =>
                <div key={index} className="w-full p-[12px] flex justify-between items-center  shadow rounded-md mb-4">
                  <div className="w-[calc(100%-60px)] flex flex-col">
                    <h3 className="text-sm">Bot Name</h3>
                    <span className="text-xs text-gray-500 mt-2 text-justify">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua</span>
                  </div>
                  <div className="w-[30px] flex flex-col items-center justify-between">
                    <button className="w-[30px] h-[30px] shadow mb-2  flex items-center justify-center rounded">
                      <CSvgBook className="fill-hoory-50 w-[18px]" />
                    </button>
                    <button className="w-[30px] h-[30px] shadow mb-2  flex items-center justify-center rounded">
                      <CSvgEdit className="stroke-hoory-50 w-[18px]" />
                    </button>
                    <button className="w-[30px] h-[30px] shadow mb-2  flex items-center justify-center rounded">
                      <CSvgTrash className="fill-hoory-50 w-[18px]" />
                    </button>

                  </div>
                </div>
              )}
            </div >
          </div>
          <div className="md:w-6/12 w-full md:pl-4 pl-0 md:mt-0 mt-10">
            <div className="w-full bg-hoory-175 rounded-md p-3 flex flex-col">
              <span className="font-bold text-sm">You can add your domain here or you can add it in your domain panel </span>
              <span className="my-2 font-bold text-[17px]">DNS Record:</span>
              <span className="text-xs mt-2">1.ns1.test.com</span>
              <span className="text-xs mt-2">2.ns1.test.com</span>
              <span className="text-xs mt-2">3.ns1.test.com</span>
              <span className="text-xs mt-2">4.ns1.test.com</span>

            </div>
          </div>
        </div>
      </div >







    </>
  )
}